/**
 * Props for the FlexPanel control
 */
export interface FlexPanelProps {
  role?: string | undefined;
  horizontal?: boolean | undefined;
  wrap?: boolean | undefined;
  fill?: boolean | undefined;
  transparent?: boolean | undefined;
  backgroundShadeClass?: string | undefined;
  className?: string | undefined;
  keyNavigationDirection?: KeyNavDir | undefined;
  tabbable?: boolean | undefined;
  memorizeCurrent?: boolean | undefined;
  "aria-label"?: string;
  mercuryDesignEnabled?: boolean | undefined;
}
/**
 * Enum denoting direction of travel while navigating via arrow keyboard keys
 */
export enum KeyNavDir {
  both = "both",
  grid = "grid",
  gridLinear = "grid-linear",
  vertical = "vertical",
  horizontal = "horizontal",
}
